import { useGlobalAuthStore } from '@Stores/global/auth';
import PrivateRoute from 'components/app-layout/PrivateRoute';
import AppRouter from 'components/app-layout/Router';

import AllocationLayout from './views/allocation/Layout';
import FormLayout from './views/form/Layout';
import OfferLayout from './views/offer/Layout';
import PublisherLayout from './views/publisher/Layout';
import SettingLayout from './views/settings/Layout';

export default function OfferRoutes() {
  const { auth: { isSuperAdmin } } = useGlobalAuthStore()
  return <AppRouter redirect='/offer/offers'>
    <PrivateRoute path="/offer/offers" component={OfferLayout} />
    <PrivateRoute path="/offer/publishers" component={PublisherLayout} />
    <PrivateRoute path="/offer/allocations" component={AllocationLayout} />
    <PrivateRoute path="/offer/forms" component={FormLayout} />
    {isSuperAdmin ? <PrivateRoute path="/offer/settings" component={SettingLayout} /> : null}
  </AppRouter>
}
